import { CommonModule } from '@angular/common';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { NotificationsService, Notification } from 'app/services/notifications.service';

@Component({
  selector: 'app-nav-notification-widget',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent],
  templateUrl: './nav-notification-widget.component.html',
  styleUrl: './nav-notification-widget.component.scss'
})
export class NavNotificationWidgetComponent {
  @ViewChild('menu') menu!: ElementRef;

  showNotifications = false;
  notifications: Notification[] = [];
  unreadCount = 0;
  menuListener: any;

  constructor(
    private notificationsService: NotificationsService,
    private renderer: Renderer2,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.notificationsService.notifications$.subscribe(notes => {
      this.notifications = notes;
      this.unreadCount = notes.filter(n => !n.seen).length;
    });
  }

  onToggleNotifications() {
    if (!this.showNotifications) {
      setTimeout(() => {
        this.menuListener = this.renderer.listen('document', 'click', (e: Event) => {
          if (!this.menu.nativeElement.contains(e.target)) {
            this.showNotifications = false;
            this.menuListener?.();
          }
        });
      }, 10);
      this.showNotifications = true;
      this.notificationsService.markAllAsSeen();
    } else {
      this.showNotifications = false;
      this.menuListener?.();
    }
  }

  onClickNotification(n) {
    console.log(n)

    switch (n.type) {
      case 'flight-watcher':
        if (n.watcherId) {
          this.router.navigate(['/watcher', n.watcherId]);
        } else {
          console.warn('Watcher ID missing.');
        }
        break;
      case 'persistent-flight-watcher':
        if (n.watcherId) {
          this.router.navigate(['/persistent-watcher', n.watcherId]);
        } else {
          console.warn('Watcher ID missing.');
        }
        break;
      case 'connection-request':
      case 'connection-accepted':
      case 'connection-canceled':
      case 'new-messages':
        if (n.connectionId) {
          this.router.navigate(['/connection', n.connectionId]);
        } else {
          console.warn('Connection ID missing.');
        }
        break;
      default:
        console.warn('No notification action detected.');
    }
  }
}
